// extracted by mini-css-extract-plugin
module.exports = {"tabs":"trackTypeTabs_tabs__yGLDd","btn":"trackTypeTabs_btn__3m8sd","selected":"trackTypeTabs_selected__3-Bg1","disabled":"trackTypeTabs_disabled__2iUhd"};